export class BannerModel {
    id: any
    name: string = ''
    type: number = 1
    info: string = ''
    imageLgUrl: string = ''
    imageSmUrl: string = ''
    imageXsUrl: string = ''
    url: string = ''
    sequence: any
    active: boolean = true
}